
import { PaymentModel } from "../../entities";
import { BaseODataRepository } from "../BaseODataRepository";

export class PaymentODataRepo extends BaseODataRepository<PaymentModel> {
  protected baseUrl = `/OData/payments`;
}

export default PaymentODataRepo;
